import StoryblokClient from 'storyblok-js-client';
import dotenv from 'dotenv';

dotenv.config();

const devMode = true;
const token = process.env.REACT_APP_SB_PREVIEW_TOKEN;
const client = new StoryblokClient({
  accessToken: token,
  cache: {
    clear: 'auto',
    type: 'memory',
  },
});
// let queryCall = {};

export const getStoryblokAPI = (slug: string, params: { version?: any; cv?: any; starts_with?: any }) => {
  params = params || {};

  if (devMode || (typeof window !== 'undefined' && window.storyblok)) {
    params.version;
  }

  if (typeof window !== 'undefined' && typeof window.StoryblokCacheVersion !== 'undefined') {
    params.cv = window.StoryblokCacheVersion;
  }

  return client.get(slug, params);
};

export const initEditor = () => {
  window.storyblok.init({
    accessToken: token,
  });

  window.storyblok.on(['change', 'published'], () => location.reload());
};
